import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Offcanvas from "../Sidebar/Offcanvas";
import userImg from "../../Images/User.png";
import logoutIcon from "../../Images/login.svg";
import { useSession } from "../../authentications/SessionContext";
import { useLanguage } from "../LangTranslation/LanguageContext";
import { SIDEBAR_OPTIONS_LIST } from "../../utilities/constants";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { primaryColor } from "../../utilities/colors";
import { useNotifications } from "../../contexts/NotificationProvider";
// import { ToastContainer } from "react-toastify";
import NotificationCenter from "../NotificationCenter/NotificationCenter";
import "react-toastify/dist/ReactToastify.css";

const StyledNavbar = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: transparent;
  color: #000000;
  @media only screen and (min-width: 769px) {
    .basketicon-container {
      display: none;
    }
  }
  .buttons {
    display: flex;
    gap: 10px;
  }
`;

const NavbarBrand = styled.span`
  font-size: 1.8rem;
  font-family: "Comfortaa";
  font-weight: 700;
  display: block;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const SearchBar = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
`;

const SearchInput = styled.input`
  padding: 8px 12px;
  border-radius: 20px;
  border: none;
  background-color: #f8f9fa;
  color: #b0b7c3;
  width: 35vw;
  font-weight: 500;
  font-family: "Inter";
  max-width: 100%;
  height: 60px;
  font-size: 20px;
  max-height: 60px;
  &:focus {
    border: none;
    outline: none;
  }
  @media only screen and (max-width: 768px) {
    width: 200px;
  }
`;

const SearchIcon = styled.span`
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  color: #b0b7c3;
  cursor: pointer;
`;

const CreateButton = styled.button`
  border-radius: 15px;
  background-color: #ff5837;
  color: #ffffff;
  border: none;
  width: 130px;
  min-width: 125px;
  height: 40px;
  margin-right: 0px;
`;

const DropdownContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const DropdownContent = styled.div`
  position: absolute;
  background-color: #f9f9f9;
  height: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;

`;

const DropdownItem = styled.div`
  padding: 7px;
  cursor: pointer;
  border-radius: 15px;
  background-color: #ddd;
  border: none;
  // width: max-content;
  min-width: max-content;
  height: 40px;
  margin: 15px;
  text-align: center;
  background-color: ${(props) => props?.color || "#ff5837"};
  color: #ffffff;
  -webkit-text-stroke: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    border: 1px solid ${(props) => props?.color || "#ff5837"};
    color: ${(props) => props?.color || "#ff5837"};
    background-color: #ffffff;
    .logout-icon {
      filter: ${(props) =>
        props?.color ||
        "invert(28%) sepia(84%) saturate(4775%) hue-rotate(347deg) brightness(97%) contrast(105%)"};
    }
  }
`;

const Navbar = ({ title, onCreateClick, showLeadButton, buttonName }) => {
  const { language, translations } = useLanguage();
  const t = translations[language];
  const { handleAuthentication, setSearchQuery, handleLogout } = useSession();
  const [searchInput, setSearchInput] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const { sessionInfo, showSidebar } = useSession();
  const { isVTEX, username } = sessionInfo;
  const dropdownRef = useRef(null);
  const { notifications } = useNotifications();
  const unreadCount = notifications.filter((notif) => !notif.read).length;
  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleChangeSearchInput = (e) => {
    const { value } = e?.target;
    setSearchInput(value || "");
    if (value === "") {
      handleSubmitSearchQuery(e, value);
    }
  };
  const toggleNotifications = () => {
    setIsNotificationOpen(!isNotificationOpen);
    setIsDropdownOpen(false); // Close user dropdown when notifications open
  };

  const handleSubmitSearchQuery = (e, value) => {
    e?.preventDefault();
    if (typeof value != "undefined") {
      setSearchQuery(value);
      return;
    }
    setSearchQuery(searchInput);
  };

  const { pathname } = useLocation();
  const selectedSideBarOption =
    SIDEBAR_OPTIONS_LIST.find(
      (sidebarOption) => pathname === sidebarOption.link
    ) || {};

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
      setIsNotificationOpen(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <StyledNavbar>
      <div className="basketicon-container">
        <Offcanvas showSidebar={showSidebar} />
      </div>
      <Helmet>
        <title>
          {selectedSideBarOption.name || ""} | Seller Portal | Xhawi
        </title>
        <meta name={selectedSideBarOption.name} />
      </Helmet>
      <NavbarBrand>{t[selectedSideBarOption.name]}</NavbarBrand>

      {/* ToastContainer */}
      {/* <ToastContainer /> */}
      {/* <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      /> */}

      {/* Notifications Toggle */}
      <div className="notification-container" onClick={toggleNotifications}>
        <i
          className="bi bi-bell"
          style={{ fontSize: "1.5rem", cursor: "pointer" }}
        ></i>
        {unreadCount > 0 && (
          <span className="notification-badge">{unreadCount}</span>
        )}
      </div>

      {/* Notification Dropdown */}
      {isNotificationOpen && (
        <div className="notification-dropdown" ref={dropdownRef}>
          <NotificationCenter />
        </div>
      )}

      <DropdownContainer ref={dropdownRef} onClick={handleDropdownToggle}>
        <img
          className="image"
          src={userImg}
          height="42px"
          width="42px"
          alt="User"
        />
        <span className="ml-3 d-none d-md-inline fw-bold">{username}</span>
        <DropdownContent
          className={`dropdown ${isDropdownOpen ? "d-block" : "d-none"}`}
        >
          <DropdownItem
            color={isVTEX ? primaryColor.primary : "#ff5837"}
            filter={
              isVTEX
                ? "invert(75%) sepia(84%) saturate(4821%) hue-rotate(210deg) brightness(100%) contrast(90%)"
                : "invert(28%) sepia(84%) saturate(4775%) hue-rotate(347deg)brightness(97%) contrast(105%)"
            }
            onClick={() => {
              if (handleLogout) {
                handleLogout();
                // return
              }
            }}
          >
            <i
              className="bi bi-box-arrow-left me-2 fa-lg"
              color={isVTEX ? primaryColor.primary : "#ff5837"}
            ></i>
            {/* <img
              className="image logout-icon"
              src={logoutIcon}
              height="32px"
              width="24px"
              alt="User"
            /> */}
            <span style={{ marginRight: ".5rem" }}> {t["Logout"]}</span>
          </DropdownItem>
        </DropdownContent>
      </DropdownContainer>
    </StyledNavbar>
  );
};

Navbar.propTypes = {
  title: PropTypes.string,
  buttonName: PropTypes.string,
};

export default Navbar;
